<h3 class="section-title">{{ 'uboReportDetails.beneficialOwnershipStructure' | transloco }}</h3>
@if (dataSource.data.length > 0) {
  <div class="table-container padding-top">
    <table mat-table [dataSource]="dataSource" matSort multiTemplateDataRows class="mat-elevation-z1">
      <!-- Name -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'common.labels.name' | transloco }}</th>
        <td mat-cell *matCellDef="let row">
          {{ formatName(row) }}
        </td>
      </ng-container>
      <!-- Shareholder Type -->
      <ng-container matColumnDef="address">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'common.labels.type' | transloco }}</th>
        <td mat-cell *matCellDef="let row">{{ formatAddress(row) }}</td>
      </ng-container>
      <!-- Shareholder Type -->
      <ng-container matColumnDef="shareholderType">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'common.labels.type' | transloco }}</th>
        <td mat-cell *matCellDef="let row">{{ row.shareholderType | enumLabel:'shareholderType' }}</td>
      </ng-container>
      <!-- Business Number -->
      <ng-container matColumnDef="businessNumber">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'common.labels.businessNumberShort' | transloco }}</th>
        <td mat-cell *matCellDef="let row">{{ row.businessNumber || '—' }}</td>
      </ng-container>
      <!-- Date of Birth -->
      <ng-container matColumnDef="dateOfBirth">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'common.labels.dob' | transloco }}</th>
        <td mat-cell *matCellDef="let row">{{ row.dateOfBirth | date: 'yyyy-MM-dd' }}</td>
      </ng-container>
      <!-- Ownership % -->
      <ng-container matColumnDef="ownershipPercentage">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="mat-column-percentage">
          {{ 'common.labels.ownershipPercentage' | transloco }}
        </th>
        <td mat-cell *matCellDef="let row" class="mat-column-percentage">
          {{ row.ownershipPercentage }}%
        </td>
      </ng-container>
      <!-- Header & Rows -->
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
}

<h3 class="section-title">{{ 'common.labels.financialRiskQuestions' | transloco }}</h3>
@if (order.ultimateBeneficialOwnershipRequest?.questions?.length) {
  <mat-card class="flex-container margin-top-25">
    <div class="margin-top-15">
      @for (question of order.ultimateBeneficialOwnershipRequest?.questions; track question; let i = $index) {
        <div class="flex-item padding">
          <div class="risk-title bold">
            {{ i + 1 }}. <span [innerHTML]="$safeNavigationMigration(question?.question)"></span>
          </div>
          <div class="risk-answer margin-sides-25 margin-top-15">
            {{ question?.answer }}
          </div>
        </div>
      }
    </div>
  </mat-card>
} @else {
  <mat-card class="card empty">
    <div class="empty-state">
      <mat-icon>help_outline</mat-icon>
      <span>{{ 'uboReportDetails.noFinancialRiskQuestionsAreAssociated' | transloco }}</span>
    </div>
  </mat-card>
}


<!-- Supporting Business Documents -->
<h3 class="section-title">{{ 'common.labels.supportingBusinessDocuments' | transloco }}</h3>
@if (order.ultimateBeneficialOwnershipRequest?.documents?.length) {
  <mat-card class="flex-container margin-top-25">
    <div class="table-wrapper">
      <table mat-table [dataSource]="order.ultimateBeneficialOwnershipRequest!.documents" class="docs-table" [attr.aria-label]="'common.labels.supportingBusinessDocuments' | transloco">
        <!-- Name Column -->
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef scope="col">{{ 'common.labels.document' | transloco }}</th>
          <td mat-cell *matCellDef="let row">
            {{ row.name }}
          </td>
        </ng-container>
        <!-- Type Column -->
        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef scope="col">{{ 'common.labels.type' | transloco }}</th>
          <td mat-cell *matCellDef="let row">
            {{ row.documentType }}
          </td>
        </ng-container>
        <!-- Actions -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef scope="col" class="text-right"></th>
          <td mat-cell *matCellDef="let row" class="text-right">
            <button
              mat-icon-button
              color="primary"
              [disabled]="isDownloading(row.id) || !row?.document?.id"
              (click)="onRowDownload(row.id)"
              [matTooltip]="'common.buttons.download' | transloco" [attr.aria-label]="'common.labels.downloadDocument' | transloco">
              @if (!isDownloading(row.id)) {
                <mat-icon>download</mat-icon>
              }
              @if (isDownloading(row.id)) {
                <mat-progress-spinner
                  mode="indeterminate"
                  [diameter]="20"
                  strokeWidth="3">
                </mat-progress-spinner>
              }
            </button>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedDocColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedDocColumns"></tr>
      </table>
    </div>
  </mat-card>
} @else {
  <mat-card class="card empty">
    <div class="empty-state">
      <mat-icon>description</mat-icon>
      <span>{{ 'uboReportDetails.noSupportingDocumentsAreAssociatedWith' | transloco }}</span>
    </div>
  </mat-card>
}

